/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { logControllerSearchOffset } from '../fn/log/log-controller-search-offset';
import { LogControllerSearchOffset$Params } from '../fn/log/log-controller-search-offset';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class LogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `logControllerSearchOffset()` */
  static readonly LogControllerSearchOffsetPath = '/api/log/search/offset';

  /**
   * 관리자 로그 오프셋 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  logControllerSearchOffset$Response(params: LogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return logControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 오프셋 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logControllerSearchOffset(params: LogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.logControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
